<template>
    <div class="tab-brief">
        <div class="tab-content">
            <div class="content-left">
                <div class="profile-photo">
                    <img :src=headImage  alt="" class="header-img">
                </div>
            </div>
            <div class="content-right" >
                <div class="name line-group">{{info.deadName}}</div>
                <div class="birthday line-group">
                    <div class="time-from time" v-if="info.birthDate">{{info.birthDate.split(' ')[0]}}</div>
                    <div class="and time">至</div>
                    <div class="time-to time" v-if="info.deathDate">{{info.deathDate.split(' ')[0]}}</div>
                </div>
                <div class="sex line-group">
                    <span class="label">性别：</span>
                    <span >{{info.sex=='1'?'男':info.sex=='2'?'女':''}}</span>
                </div>
                <div class="native line-group">
                    <span class="label">籍贯：</span>
                    <span >{{info.areaCode}}</span>
                </div>
                <div class="introduction line-group">
                    <span class="label">简介：</span>
                    <span v-html="info.life"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    let self
    import util from '../../../utils/util'
    export default {
        components: {

        },
        props:{
            info :{
                type:Object,
                default(){
                    return {}
                }
            }
        },
        watch:{
            'info.templateId'(id){
                this.templateImage = require(`../../../assets/images/gif/${id}.gif`)
            },
            'info.headImage'(src){
                this.headImage = src.replace('website.seabury.sfitech','website.seabury.dev.sfitech')
                console.log('watchHeadImgafter----',this.headImage)
                // util.getImgSize(this.headImage,function (w,h) {
                //     // console.log('w----',w)
                //     // console.log('h----',h)
                //     util.parseImgStyle(w,h,self,'headImgStyle')
                // })
            }
        },
        data(){
            return{
                src:'',
                headImage:'',
                // headImgStyle:{
                //     width:'100%',
                //     height:'100%'
                // },
            }
        },
        mounted(){
            self = this;
            this.src=require('../../../assets/images/p1.png')
        },
        methods:{

        }
    }
</script>

<style scoped lang="scss">
    .tab-content{
        overflow: hidden;
        padding: 60px 50px;
        .content-left{
            float: left;
            .profile-photo{
                width: 194px;
                height: 258px;
                overflow: hidden;
                .header-img{
                    max-height: 100%;
                    max-width: 100%;
                    position: relative;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50% ,-50%);
                }
            }
        }
        .content-right{
            float: left;
            width: 740px;
            text-align: left;
            margin-left: 40px;
            .line-group{
                padding:5px 0;
                &:first-child{
                    padding: 0;
                }
            }
            .name{
                font-size: 22px;
                font-weight: bold;
            }
            .birthday{
                overflow: hidden;
                .time{
                    float: left;
                }
                .and{
                    padding: 0 10px;
                }
            }
        }
    }
</style>
